import type { BannerItem } from "$root/components/banner-stack/types";
import type { Instrument } from "../const";

export type InstrumentLimitReachedBannerDeps = {
	rows: Instrument[];
	/** Omitted: the editor has no maximum. */
	limit?: number;
};

export function instrumentLimitReachedBanner({ rows, limit }: InstrumentLimitReachedBannerDeps): BannerItem | null {
	if (!limit || rows.length <= limit) {
		return null;
	}

	return {
		id: "instrument-limit-reached",
		severity: "warning",
		title: "Instrument limit reached",
		description: (
			<>
				You have exceeded the maximum number of instruments allowed for your portfolio ({">"} <strong>{limit}</strong>
				). Please remove instruments or one or more portfolios from your mixed portfolio to stay within this limit of{" "}
				{limit} instruments.
			</>
		),
	};
}
